export default __webpack_public_path__ + "static/media/roundSquare.17d1a0ee.svg";